<template>
  <info-dialog v-if="report" :disableAutoMargin="true" v-model="isActive" max-width="80vw">

    <template slot="title">
      <span
        v-html="$t('reports.label.titolo_report_html', { num: report.numero, data: $d($utils.date.toJs(report.data_controllo)) })"></span>
    </template>

      <v-flex xs12 md4>
        <div>
          <v-btn class="ma-0" color="error" @click="downloadPDF" :loading="pdfDownloading">
            <v-icon left>file_download</v-icon>
            {{ $t('reports.label.rapporto_prova') }}
          </v-btn>
        </div>
        <div v-if="report.allegati && report.allegati.length > 0" class="mt-2">
          <v-btn class="ma-0" color="secondary" @click="downloadAttachments" :loading="attachmentsLoading">
            <v-icon left>file_download</v-icon>
            {{ report.allegati.length }} {{ $t('label.allegati') }} (.zip)
          </v-btn>
        </div>
        <div v-if="showPdfPopup" class="mt-2">
          <v-btn class="ma-0" color="secondary" @click="sendPerMail" :disabled="!report || !report.agricoltore || !report.agricoltore.email">
            <v-icon left>mail</v-icon>
            {{ $t('label.invia_per_mail') }}
          </v-btn>
        </div>

        <div class="mb-2 mt-4">{{ $t('label.cliente') }}: <b>{{ report.agricoltore && report.agricoltore.ragione_sociale ?
          report.agricoltore.ragione_sociale : "-" }}</b></div>
        <div class="mb-2">{{ $t('prenotazioni.label.tecnico') }}: <b>{{ report.tecnico ? report.tecnico.nome_cognome : "-"
            }}</b></div>
        <div class="mb-2">{{ $t('label.indirizzo') }}: <b>{{ report.formattedAddress }}</b></div>
        <div class="mb-2 mt-4">{{ $t('reports.label.tipologia') }}: <b>{{ report.tipoTradotto }}</b></div>
        <div class="mb-2">{{ $t('prenotazioni.label.marca') }}: <b>{{ report.marca }}</b></div>
        <div class="mb-2">{{ $t('prenotazioni.label.modello') }}: <b>{{ report.modello }}</b></div>
        <div class="mb-2">{{ $t('reports.label.numero_serie') }}: <b>{{ report.numero_serie }}</b></div>
        <div v-if="!report.fromScadenza" class="mb-2">{{ $t('reports.label.scadenza') }}: <b>{{ report.scadenza ?
          report.scadenza : "-"
            }}</b>
        </div>
      </v-flex>

      <v-flex xs12 md8 style="min-height: 80vh;">
        <gmap :loading="loading" v-if="!showPdfPopup">
          <gmap-marker v-if="location" :position="location" color="#cf432c" label="A">
            <div class="body-2 py-1">
              <span class="title ml-2"><b>{{ report.numero }}</b>, {{ report.agricoltore.ragione_sociale }}</span>
            </div>
          </gmap-marker>
        </gmap>

        <div v-if="showPdfPopup" class="pdf-container"> <!-- Per la visualizzazione del pdf -->
          <div class="loader-overlay">
            <div class="loader"></div>
          </div>
          <iframe v-if="pdfUrl" id="pdf-image" :src="pdfUrl"> </iframe>
        </div>
      </v-flex>

  </info-dialog>
</template>

<script>
import Toggleable from '@/mixins/toggleable'
import Gmap from '@/components/gmap/Gmap'
import GmapMarker from '@/components/gmap/GmapMarker'
import InfoDialog from '@/components/base/InfoDialog'

export default {
  name: 'ReportDialog',
  mixins: [Toggleable],
  components: { Gmap, GmapMarker, InfoDialog },
  data: () => ({
    report: null,
    loading: false,
    pdfDownloading: false,
    attachmentsLoading: false,
    location: null,
    showPdfPopup: false,
    pdfUrl: null,
    pdf: null
  }),
  methods: {
    async show(report, fromScadenza, showPdf) {
      this.pdfUrl = null;

      if (!this.$store.state || !this.$store.state.agricoltori || !this.$store.state.agricoltori.length) {
        await this.$store.dispatch('loadAgricoltori');
      }

      if (showPdf) {
        this.showPdfPopup = true;

        if (report.tipo == "0")
          report.tipoTradotto = this.$t('prenotazioni.label.erbacee')
        else if (report.tipo == "1")
          report.tipoTradotto = this.$t('prenotazioni.label.arboree')
        else
          report.tipoTradotto = report.tipo

        this.report = {
          ...report,
          agricoltore: this.$store.getters.getAgricoltoreById(report.id_agricoltore),
          tecnico: this.$store.getters.getTecnicoById(report.id_tecnico),
          formattedAddress: this.$utils.formatAddress(report.nazione, report.regione, report.provincia, report.comune, report.cap, report.frazione, report.via, report.numero_civico),
          fromScadenza: fromScadenza
        }

        let data = this.report.data_controllo.replace(/-/g, "")

        this.$api.reports.previewPDF(this.report.numero, this.report.anno, data, this.report.numero_serie, this.report.agricoltore.cuaa)
          .then(url => {
            this.pdfUrl = url;
          });

        this.fetchMarkerPosition()
        this.isActive = true
      }
    },
    downloadPDF() {
      this.pdfDownloading = true;

      let data = this.report.data_controllo.replace(/-/g, "")

      this.$api.reports.downloadPDF(this.report.numero, this.report.anno, data, this.report.numero_serie, this.report.agricoltore.cuaa).then(() => {
        this.pdfDownloading = false
      }).catch(e => {
        this.pdfDownloading = false
        this.$snackbar.showServerError(e)
      })
    },
    sendPerMail() {
      this.$confirmDialog.show(
        {  report: this.report },
        this.$t('reports.messaggi.invio_report'),
        function (params, lang) {
          let data = params.report.data_controllo.replace(/-/g, "");
          this.$api.reports.sendMail(params.report.numero, params.report.anno, data, params.report.numero_serie, params.report.agricoltore.cuaa, lang).then(() => {
            this.$snackbar.show(this.$t('reports.label.email_inviata_correttamente'), 'success')
          }).catch(e => {
            this.$snackbar.showServerError(e)
          })
        },
        {
            showLanguageSelector: true,
        });
    },
    async loadPdf(url) {
      // carica il documento
      this.pdf = await pdfjsLib.getDocument(url).promise;

      const container = this.$refs.pdfContainer;
      container.innerHTML = "";

      // renderizza tutte le pagine
      for (let i = 1; i <= this.pdf.numPages; i++) {
        const page = await this.pdf.getPage(i);

        const viewport = page.getViewport({ scale: 1.2 });
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");
        canvas.height = viewport.height;
        canvas.width = viewport.width;

        container.appendChild(canvas);

        await page.render({
          canvasContext: context,
          viewport: viewport
        }).promise;
      }
    },
    downloadAttachments() {
      this.attachmentsLoading = true
      this.$api.reports.downloadAttachments(this.report.numero, this.report.anno).then(() => {
        this.attachmentsLoading = false
      }).catch(e => {
        this.attachmentsLoading = false
        this.$snackbar.showServerError(e)
      })
    },
    fetchMarkerPosition() {
      this.loading = true
      this.$api.indirizzo.resolveGmapAddress(this.report.formattedAddress).then(response => {
        this.location = response.data.results[0].geometry.location
        this.loading = false
      }).catch(e => {
        this.loading = false
        this.$snackbar.showServerError(e)
      })
    },
    impostaRinnovato() {
      var dataReport = {
        id: this.report.id_prenotazione,
        ...this.report
      }
      this.$api.reports.setRinnovato(this.report.id_prenotazione, dataReport).then(() => {
        this.$snackbar.show(this.$t('reports.label.rinnovato_correttamente'), 'success')
      }).catch(e => {
        this.attachmentsLoading = false
        this.$snackbar.showServerError(e)
      })
    },
    modificaFatturato() {
      var dataReport = {
        id: this.report.id_prenotazione,
        ...this.report
      }
      this.$api.reports.setFatturato(this.report.id_prenotazione, dataReport).then(() => {
        this.$snackbar.show(this.$t('reports.label.modificato_correttamente'), 'success')
        this.isActive = false
        this.$emit('success')
      }).catch(e => {
        this.attachmentsLoading = false
        this.$snackbar.showServerError(e)
        this.$emit('error')
      })
    },
    AtFatturatoChanged() {
      this.$emit('success')
    }
  }
}
</script>

<style lang="scss" scoped>
.map-view {
  width: 300px;
  height: 300px;
}

.pdf-container {
  position: relative;
  width: 100%;
  height: 100%;
}

.loader-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
}

.loader {
  border: 8px solid #f3f3f3;
  border-top: 8px solid #3498db;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  animation: spin 1s linear infinite;
}

#pdf-image {
  position: absolute;
  z-index: 2;
  width: 100%;
  min-height: 80vh;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>